<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData()">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Movimento de Stock</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="mr-2 mb-2" fill-height
                  v-model="search"
                  append-icon="search"
                  label="procurar stocks..."
                  clearable
                  single-line
                  hide-details
            ></v-text-field>

            <!--Dialog for add and edit-->
            <v-btn v-if="permissionToAdd" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
            <stock-form-modal
                :simplifiedModal="false"
                :articles="products"
                @onStockFormDone="fetchData()"
            ></stock-form-modal>
        </v-toolbar>

        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="stocks"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            :pagination.sync="pagination"
            hide-actions
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            disable-initial-sort
        >
            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td class="text-xs-left">{{ props.item.article.name }}</td>
                <td class="text-xs-right">
                    <span style="font-weight: bold" :style="props.item.quantity > 0 ? {'color': 'green'} : {'color': '#F22'}">
                        <span v-if="props.item.quantity > 0">+ {{ props.item.quantity}}</span>
                        <span v-if="props.item.quantity < 0">- {{(props.item.quantity * (-1))}}</span>
                    </span>
                </td>
                <td class="text-xs-right">{{ props.item.quantity_before_movement}}</td>
                <td class="text-xs-right">{{ props.item.quantity_before_movement + props.item.quantity}}</td>
                <td class="text-xs-right">{{ props.item.movement_type_name }}</td>
                <td class="text-xs-right">{{ props.item.user.name }}</td>
                <td class="text-xs-right" style="white-space:nowrap">{{ props.item.created_at | formatDateHour}}</td>
                <!--<td class="text-xs-right">{{ props.item.description}}</td>-->
                <td class="text-xs-right" style="min-width: 120px; padding-right: 10px;">
                    <v-icon v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>
                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData()"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

    </div>
</template>

<script>
/* eslint-disable */
    import Vue from 'vue';
    import {Permissions, Global} from "../../config";
    import {mapGetters} from 'vuex';

    import StockFormModal from '../stock/StockFormModal';
    import CustomPagination from '../extra/CustomPagination.vue';
    
    export default {
        name: "Stocks",

        data(){
            return {
                Global,
                Permissions,
                pagination: {},
                totalData: 0,
                loading: false, //loading for list of stocks in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false,  //error for fetching list of stocks in the datatable
                search: '', //search for the datatable
                headers: [
                    { text: 'Produto', align: 'left', value: 'name' },
                    { text: 'Quantidade', align: 'right', value: 'a1'},
                    { text: 'Antes Movimento', align: 'right', value: 'quantity_before_movement' },
                    { text: 'Depois Movimento', align: 'right', value: 'a2' },
                    { text: 'Tipo Movimento', align: 'right', value: 'movement_type_name'},
                    { text: 'Pelo utilzador', align: 'right', value: 'category_name'},
                    { text: 'Data', align: 'right', value: 'subcategory_name'},
                    // { text: 'Descrição', align: 'right', value: '', sortable: false },
                    { text: 'Ações', align: 'right', value: '', sortable: false },
                ],

                stocks: [],
                products: [],
                onlyTrashed: false, //displays only trashed items or not

            }
        },

        components: {
            StockFormModal,
            CustomPagination,
            // ConfirmationDialog,
        },

        watch: {
            pagination(){
                this.fetchData();
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
        },

        computed: {
            ...mapGetters([
                'getNewCompany',
                'getToken'
            ]),
            permissionToAdd(){
                return this.hasPermission(Permissions.STOCK_ADD);
            },
            permissionToUpdate(){
                // return this.hasPermission(Permissions.STOCK_UPDATE);
            },
            permissionToDelete(){
                // return this.hasPermission(Permissions.STOCK_DELETE);
            },
            showStockModal: {
                get(){
                    return this.$store.getters.getShowStockModal;
                },
                set(value){
                    this.$store.dispatch('setShowStockModal', value);
                }
            },
            selectedStock: {
                get(){
                    return this.$store.getters.getSelectedStock;
                },
                set(value){
                    this.$store.dispatch('setSelectedStock', value);
                }
            },
            stockShow: {
                get(){
                    return this.$store.getters.getStockShow;
                },
                set(value){
                    this.$store.dispatch('setStockShow', value);
                }
            },

        },

        methods: {

            noDataText(){
                return this.loading ? 'a carregar stocks ...' : 'nenhum stock.';
            },

            paginationChangeCallBack(payload){
                this.consoleLog('paginationChangeCallBack');
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            fetchData(){
                if(this.loading) return;
                try{

                    this.stocks = [];
                    this.loading = true;
                    this.error_fetching = false;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get('stock', {
                        params: {                            
                            pag_size: this.pagination.rowsPerPage,
                            pag_current: this.pagination.page,
                            sort_field: this.getSortBy(this.pagination),
                            sort_order: this.getSortDes(this.pagination),
                            search: this.search,
                        }
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.loading = false;
                            this.error_fetching = true;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }

                        this.stocks = response.data.response.stocks;
                        this.products = response.data.response.products;

                        this.totalData = response.data.response.total_data;

                        this.totalRows = this.stocks.length;
                    }).catch(error => {
                        this.consoleLog(error);
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar lista de stocks.!', 'error');
                    }).finally(()=>{
                        this.loading = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao carregar lista de stocks!', 'error');
                    this.loading_modal = false;
                }
            },

            showItem (item) {
                this.stockShow = true;
                this.selectedIndex = this.stocks.indexOf(item);
                this.selectedStock = item;
                this.showStockModal = true;
                this.consoleLog('onStockModalOpen', item);
            },

            close () {
                this.showStockModal = false;
                this.loading = false;
                this.stockShow = false;
                if(this.$v) this.$v.$reset();
                setTimeout(() => {
                    this.selectedIndex = -1
                }, 300)
            },

            openModal(){
                this.consoleLog('open modal');
                this.selectedStock = null;
                this.showStockModal = true;
            },

        },

    }
</script>

<style scoped>

</style>